export const essentials_PromoteEvents = [
	{
		icon: '🎟️',
		subtitle: 'essentialData_subtitle1',
	},
	{
		icon: '🎨',
		subtitle: 'essentialData_subtitle2',
	},
	{
		icon: '🥁',
		subtitle: 'essentialData_subtitle3',
	},
	{
		icon: '🤘',
		subtitle: 'essentialData_subtitle4',
	},
];
